import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class RankingList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        // console.log(content);
        const title = (
            <div className={styles.title}>
                <h3>排行榜</h3>
            </div>
        );
        const listBody = (
            <div className={`${styles.listBody} ${content[0] && !content[0].img ? styles.noimgbg : ''}`}>
                <ul>
                    {content.map((item, index) => {
                        if (index === 0) {
                            return (
                                <li className={item.img ? styles.firstItem : ''} key={index}>
                                    <a href={item.url} target="_self" title={item.title}>
                                        {item.img ? (
                                            <React.Fragment>
                                                <img src={item.img ? item.img : ''} alt={item.title} />
                                                <i />
                                                <em />
                                                <span className={styles.vTitle}>{item.title}</span>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <span className={styles.vTitle}>{item.title}</span>
                                            </React.Fragment>
                                        )}

                                        <strong style={{ top: item.img ? '0' : '16px' }} className={styles.firstIcon} />
                                    </a>
                                </li>
                            );
                        } else {
                            return (
                                <li key={index}>
                                    <a href={item.url} target="_self" title={item.title}>
                                        <span className={styles.vTitle}>{item.title}</span>
                                    </a>
                                </li>
                            );
                        }
                    })}
                </ul>
            </div>
        );

        return (
            <div className={styles.rankingList}>
                {title}
                {content && Array.prototype.isPrototypeOf(content) && content.length > 0 ? listBody : null}
            </div>
        );
    }
}

export default errorBoundary(RankingList);
